/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance(value) {
    if (!('ReasonText' in value) || value['ReasonText'] === undefined)
        return false;
    if (!('ReasonTextFallback' in value) || value['ReasonTextFallback'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ReasonText': json['ReasonText'],
        'ReasonTextFallback': json['ReasonTextFallback'],
        'DateStart': json['DateStart'] == null ? undefined : (new Date(json['DateStart'])),
        'DateEnd': json['DateEnd'] == null ? undefined : (new Date(json['DateEnd'])),
        'ForceStop': json['ForceStop'] == null ? undefined : json['ForceStop'],
        'EmailsExcluded': json['EmailsExcluded'] == null ? undefined : json['EmailsExcluded'],
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ReasonText': value['ReasonText'],
        'ReasonTextFallback': value['ReasonTextFallback'],
        'DateStart': value['DateStart'] == null ? undefined : (value['DateStart'].toISOString()),
        'DateEnd': value['DateEnd'] == null ? undefined : (value['DateEnd'].toISOString()),
        'ForceStop': value['ForceStop'],
        'EmailsExcluded': value['EmailsExcluded'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance.js.map